import '../style/yearpage.css';
import { useNavigate } from 'react-router-dom';
import MexicoImage from '../components/mexico.jpg';
import AlbaniaImage from '../components/albania.jpg';
import IrelandImage from '../components/ireland.jpg';
import MontenegroImage from '../components/montenegro.webp';

function Year2022() {
    const navigate = useNavigate(); // Initialize the navigate function
  
    // Function to handle container clicks
    const handleContainerClick = (path) => {
      navigate(path); // Navigate to the specified path
    };

    const handleBackClick = () => {
      navigate('/'); // Navigate to the home page
    };
  
    return (
      <div className="year-page">
        <h1>2022 Photos</h1>
        <button 
        className="back-button" 
        onClick={handleBackClick}
      >
        ← Back 
      </button>
        <div className="location-grid">
          {/* Mexico Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/mexico')} // Redirect to /mexico
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${MexicoImage})` }}
            ></div>
            <p className="location-name">Mexico</p>
          </div>
  
          {/* Albania Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/albania')} // Redirect to /albania
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${AlbaniaImage})` }}
            ></div>
            <p className="location-name">Albania</p>
          </div>
  
          {/* Ireland Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/ireland')} // Redirect to /ireland
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${IrelandImage})` }}
            ></div>
            <p className="location-name">Ireland</p>
          </div>
  
          {/* Montenegro Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/montenegro')} // Redirect to /montenegro
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${MontenegroImage})` }}
            ></div>
            <p className="location-name">Montenegro</p>
          </div>
        </div>
      </div>
    );
  }
  
  export default Year2022;